import { render } from "./AboV2Vehicles.vue?vue&type=template&id=011fb077"
import script from "./AboV2Vehicles.vue?vue&type=script&lang=js"
export * from "./AboV2Vehicles.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ORM_CRENT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__